<template>
  <div class="container">
    <Header />
    <br /><br /><br /><br /><br /><br />
    <h3>Frequently Asked Questions</h3>
    <br />
    <h5>
    Q: How can I contact Unibud ?<br />
    A: Send a text to (818) 836-0342<br />
    <br />
    Q: How can I cancel my delivery order ?<br />
    A: Please text us at (818) 836-0342 to cancel.<br />
    <br />
    Q: What is your legal delivery license ?<br />
    A: Adult-Use Retail: C10-0000496-LIC<br />

    </h5>
    <br />
    <Footer />
  </div>
</template>

<script>

import Header from "../components/header";
import Footer from "../components/footer";

import {mapGetters} from "vuex";


export default {
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapGetters({
    })
  },
  data() {
    return {
    };
  },
  methods:{
  },
};
</script>
